<ng-template #tipContent><div [innerHTML]="text"></div></ng-template>
<span class="d-none d-print-inline">(<span [innerHTML]="text"></span>)</span>
<button
    type="button"
    class="icon-gard-info bg-transparent border-0 p-0 d-print-none"
    [id]="'tooltip-m-' + rid"
    [ngClass]="mobileIconClass"
    [attr.aria-label]="accessibleLabel"
    [ngbTooltip]="tipContent"
    [popperOptions]="popperOptions"
    placement="auto"
    triggers="click:blur"
    (click)="onTooltipClick($event)"
></button>
